import type { ReactNode } from 'react';

/**
 * v0.5 (Ivan): an entry's change history stays out of the overview. A quiet "Show history" at the
 * bottom opens it; it starts closed every time (nothing is remembered).
 */
export function HistoryDisclosure({
  label = 'Show history',
  children,
}: {
  label?: string;
  children: ReactNode;
}) {
  return (
    <details className="group">
      <summary className="inline-flex min-h-11 cursor-pointer list-none items-center rounded-full px-3 text-sm text-primary hover:bg-secondary focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-[var(--ring)] [&::-webkit-details-marker]:hidden">
        <span className="group-open:hidden">{label}</span>
        <span className="hidden group-open:inline">Hide history</span>
      </summary>
      <div className="mt-2">{children}</div>
    </details>
  );
}
